// Hands the picked file from the gallery trigger to the content-upload controller in the modal.
let pendingFile = null

export function setPendingFile(file) {
  pendingFile = file
}

export function takePendingFile() {
  const file = pendingFile
  pendingFile = null

  return file
}
